
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { HttpHelperService } from "../services/http-helper.service";
import { ResultCardComponent } from "../components/result-card/result-card.component";
import { SkeletonLoaderComponent } from "../components/skeleton-loader/skeleton-loader.component";
import { SelectComponent } from "../components/select/select.component";
import { ProfileImageStackComponent } from "../components/profile-image-stack/profile-image-stack.component";
import { PinManagerModalComponent } from "../components/pin-manager-modal/pin-manager-modal.component";
import { PinManagerButtonComponent } from "../components/pin-manager-button/pin-manager-button.component";
import { MatDialogModule } from '@angular/material/dialog';
import { TabsComponent } from "../components/tabs/tabs.component";
import { TabComponent } from "../components/tab/tab.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { SliderComponent } from "../components/slider/slider.component";
import { ConfirmationModalComponent } from '../components/confirmation-modal/confirmation-modal.component';
import { ToastErrorDetailComponent } from '../components/toast-error-detail/toast-error-detail.component';
import { TagComponent } from '../components/tag/tag.component';
import { ColorPickerModule } from "@iplab/ngx-color-picker";
import { SelectSingleComponent } from '../components/select-single/select-single.component';
import { ProfileImageComponent } from '../components/profile-image/profile-image.component';
import { TooltipComponent } from '../components/tooltip/tooltip.component';
import { TooltipDirective } from "../directives/tooltip.directive";
import { MultiSelectComponent } from '../components/multi-select/multi-select.component';
import { ContextMenuComponent } from '../components/context-menu/context-menu.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DropdownPositionDirective } from "../directives/dropdown-position.directive";
import { AvatarBgColorDirective } from "../directives/avatar-bg-color.directive";
import { DateTimeFormatPipe } from "../pipes/date-time-format.pipe";
import { SafeHtmlPipe } from "../pipes/safehtml.pipe";
import { HighlightPipe } from "../pipes/highlight.pipe";
import { CalendarActivityComponent } from "../components/calendar-activity/calendar-activity.component";
import { EmptyStateComponent } from "../components/empty-state/empty-state.component";
import { LucideIconsModule } from "./lucide-icons.module";
import { RolePipe } from "../pipes/role.pipe";
import { UserOnboardingComponent } from "../components/user-onboarding/user-onboarding.component";
import { TourGuideComponent } from "../components/tour-guide/tour-guide.component";
import { TourFloatingButtonComponent } from "../components/tour-floating-button/tour-floating-button.component";
import { HeaderTourButtonComponent } from "../components/header-tour-button/header-tour-button.component";
import { SlidingTourPanelComponent } from "../components/sliding-tour-panel/sliding-tour-panel.component";
import { TourNotificationComponent } from "../components/tour-notification/tour-notification.component";
import { LoadingModalComponent } from '../components/loading-modal/loading-modal.component';
import { IconsDropdownComponent } from "../components/icons-dropdown/icons-dropdown.component";
import { IconSelectComponent } from "../components/icon-select/icon-select.component";
import { JsonBuilderComponent } from "../components/json-builder/json-builder.component";
import { HighlightDirective } from "../directives/highlight.directive";
import { CalendarSkeletonLoaderComponent } from "../components/calendar-skeleton-loader/calendar-skeleton-loader.component";
import { FloatingLoaderComponent } from "../components/floating-loader/floating-loader.component";
import { ActivitySkeletonLoaderComponent } from "../components/activity-skeleton-loader/activity-skeleton-loader.component";
import { SidebarSkeletonLoaderComponent } from "../components/sidebar-skeleton-loader/sidebar-skeleton-loader.component";
import { MultiSelectChipComponent } from "../components/multi-select-chip/multi-select-chip.component";



@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    ScrollingModule,
    ColorPickerModule,
    MatAutocompleteModule,
    LucideIconsModule,
  ],
  exports: [
    LucideIconsModule,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule,
    ResultCardComponent,
    SkeletonLoaderComponent,
    SelectComponent,
    ProfileImageStackComponent,
    PinManagerModalComponent,
    PinManagerButtonComponent,
    TabsComponent,
    TabComponent,
    ScrollingModule,
    SliderComponent,
    TagComponent,
    SelectSingleComponent,
    ProfileImageComponent,
    TooltipComponent,
    TooltipDirective,
    HighlightDirective,
    MultiSelectComponent,
    ContextMenuComponent,
    MatAutocompleteModule,
    DropdownPositionDirective,
    AvatarBgColorDirective,
    DateTimeFormatPipe,
    SafeHtmlPipe,
    HighlightPipe,
    RolePipe,
    CalendarActivityComponent,
    EmptyStateComponent,
    UserOnboardingComponent,
    TourGuideComponent,
    TourFloatingButtonComponent,
    HeaderTourButtonComponent,
    SlidingTourPanelComponent,
    TourNotificationComponent,
    LoadingModalComponent,
    IconSelectComponent,
    JsonBuilderComponent,
    IconsDropdownComponent,
    CalendarSkeletonLoaderComponent,
    FloatingLoaderComponent,
    ActivitySkeletonLoaderComponent,
    SidebarSkeletonLoaderComponent,
    MultiSelectChipComponent,
  ],
  declarations: [
    ResultCardComponent,
    SkeletonLoaderComponent,
    SelectComponent,
    ProfileImageStackComponent,
    PinManagerModalComponent,
    PinManagerButtonComponent,
    TabsComponent,
    TabComponent,
    SliderComponent,
    ConfirmationModalComponent,
    ToastErrorDetailComponent,
    TagComponent,
    SelectSingleComponent,
    ProfileImageComponent,
    TooltipComponent,
    TooltipDirective,
    MultiSelectComponent,
    ContextMenuComponent,
    DropdownPositionDirective,
    AvatarBgColorDirective,
    HighlightDirective,
    DateTimeFormatPipe,
    SafeHtmlPipe,
    HighlightPipe,
    RolePipe,
    CalendarActivityComponent,
    EmptyStateComponent,
    UserOnboardingComponent,
    TourGuideComponent,
    TourFloatingButtonComponent,
    HeaderTourButtonComponent,
    SlidingTourPanelComponent,
    TourNotificationComponent,
    LoadingModalComponent,
    IconSelectComponent,
    JsonBuilderComponent,
    CalendarSkeletonLoaderComponent,
    FloatingLoaderComponent,
    ActivitySkeletonLoaderComponent,
    SidebarSkeletonLoaderComponent,
    IconsDropdownComponent,
    MultiSelectChipComponent,
  ],
  providers: [HttpHelperService],
})
export class SharedModule { }
